const HMKError = () => (
    <div><h1>ERROR : You're not connected to a project.</h1></div>
)

export default HMKError
